import {
  faChevronRight,
  faClock,
  faGraduationCap,
  faRocket,
} from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TalkingParrot from '../../../assets/images/talking-parrot.png';
import axios from '../../../api/axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import crypto from 'crypto';
import HtmlInput from '../../UI/HtmlInput';
import Checkbox from '../../UI/Checkbox';
import {useTranslation} from 'react-i18next';

const Unsubscribe = () => {
  const {t: translate } = useTranslation();
  const { search } = useLocation();
  const [errors, setErrors] = useState({});
  const emailAddressRef = useRef();
  const learningRef = useRef();
  const summaryRef = useRef();
  const history = useHistory();

  const handleUnsubscribe = (evt) => {
    evt.preventDefault();

    const email = emailAddressRef.current.value;
    const learning = learningRef.current.checked;
    const summary = summaryRef.current.checked;
    let errorFlag = {
      'updates' : false,
      'email' : false
    };

    if (!learning && !summary) {
      setErrors((prevState) => ({
        ...prevState,
        updates: translate('select-update-option'),
      }));

      errorFlag['updates'] = true;
    } else {
      errorFlag['updates'] = false;
      setErrors((prevState) => ({
        ...prevState,
        updates: null,
      }));
    }

    if (email.length === 0) {
      setErrors((prevState) => ({
        ...prevState,
        email: translate('enter-email'),
      }));

      errorFlag['email'] = true;
    } else {
      errorFlag['email'] = false;
      setErrors((prevState) => ({
        ...prevState,
        email: null,
      }));
    }

    //Stop form submitting if errors
    if( Object.values(errorFlag).includes(true) ) return;

    if (validateEmail(email)) {
      const params = new URLSearchParams(search);

      if (!params.get('m') || !params.get('e')) {
        setErrors({ email: translate('email-invalid') });
      } else {
        if (params.get('e')) {
          const eVal = params.get('e');
          const hashedEmail = crypto
            .createHash('md5')
            .update(email)
            .digest('hex');

          if (eVal.toLowerCase() !== hashedEmail.toLowerCase()) {
            setErrors({ email: translate('email-invalid') });
          } else {
            params.append('email', email);
            params.append('learning', learning);
            params.append('summary', summary);

            axios
              .put(`/unsubscribe`, params, {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
              })
              .then((response) => {
                if (response.status === 200) {
                  let url = `/unsubscribe/confirmed?learning=${learning}&summary=${summary}`;

                  history.push(url);
                }
              })
              .catch((error) => {
                console.log(error.message);
                setErrors({
                  email: translate('expired-email')
                });
              });
          }
        }
      }
    }
  };

  const validateEmail = (email) => {
    if (email.length > 0) {
      setErrors({});
    }

    const isValid = String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );

    if (!isValid) {
      setErrors({ email: translate('email-invalid') });
    }

    return isValid;
  };

  return (
    <div className="unsubscribe">
      <div className="unsubscribe__box">
        <img
          src={TalkingParrot}
          alt="golingo Parrot"
          title="golingo Parrot"
          className="parrot"
        />
        <div className="unsubscribe__content">
          <h1>{translate('unsubscribe-title')}</h1>
          <div className="reasons-box">
            <p className="reasons">
              <FontAwesomeIcon icon={faClock} size="1x" />
              {translate('unsubscribe-reason-1')}
            </p>
            <p className="reasons">
              <FontAwesomeIcon icon={faGraduationCap} size="1x" />
              {translate('unsubscribe-reason-2')}
            </p>
            <p className="reasons">
              <FontAwesomeIcon icon={faRocket} size="1x" />
              {translate('unsubscribe-reason-3')}
            </p>
          </div>
          <div className="unsubscribe__form">
            <p>
              {translate('unsubscribe-form')}
            </p>
            <form
              noValidate
              id={'unsub-form'}
              className={'unsub-form'}
              onSubmit={handleUnsubscribe}
            >
              <div className="input-row input-row--centre">
                <Checkbox
                  id="learning"
                  name="learning"
                  label="Learning Reminders"
                  inputRef={learningRef}
                />
                <Checkbox
                  id="summary"
                  name="summary"
                  label="Weekly Summary"
                  inputRef={summaryRef}
                />
              </div>
              <span
                className="input-row__error"
                style={{ display: errors.updates ? 'block' : 'none' }}
              >
                {errors.updates}
              </span>
              <div className="input-row">
                <HtmlInput
                  id="emailId"
                  type="email"
                  name="email"
                  legend="Email"
                  inputRef={emailAddressRef}
                  hasErrors={'email' in errors}
                />
              </div>
              <span
                className="input-row__error"
                style={{ display: errors.email ? 'block' : 'none' }}
              >
                {errors.email}
              </span>

              <div className="form-group">
                <button className={'button'} title={'Click to unsubscribe'}>
                  <span>{translate('unsubscribe')}</span>
                  <FontAwesomeIcon icon={faChevronRight} size="1x" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
